import { lazyGetAssetCommandMenuItems } from 'owa-calendar-board-commanding';
import type { AssetId } from 'owa-timestream-types';

export function getAssetCommandItems(selectedAssets: AssetId[]) {
    const getAssetCommandMenuItems = lazyGetAssetCommandMenuItems.tryImportForRender();

    return getAssetCommandMenuItems ? getAssetCommandMenuItems(selectedAssets) : [];
}
